import axios from 'axios';
import { CouponResponse, RedemptionResponse, SubscriberDetailsResponse } from '../types/coupon';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const publicApi = {
    getCouponDetails: (couponId: string) => {
        return axios.get<CouponResponse>(`${API_URL}/api/public/coupons/${couponId}`);
    },

    checkSubscription: (couponId: string, email: string) => {
        return axios.get(`${API_URL}/api/public/coupons/${couponId}/check-subscription`, {
            params: { email }
        });
    },

    registerCustomer: (couponId: string, data: { firstName: string; lastName: string; email: string }) => {
        return axios.post(`${API_URL}/api/public/coupons/${couponId}/register`, data);
    },

    generateCouponImage: (couponId: string, params: { customerName: string; customerEmail: string; subscriberId: string }) => {
        return axios.get(`${API_URL}/api/public/coupons/${couponId}/generate-image`, {
            params,
            responseType: 'blob'
        });
    },

    getRedemptionStatus: (couponId: string, params: { email: string; subscriberId: string }) => {
        return axios.get<RedemptionResponse>(
            `${API_URL}/api/public/coupons/${couponId}/redemption-status`,
            { params }
        );
    },

    redeemCoupon: (couponId: string, data: { email: string; subscriberId: string }) => {
        return axios.post<RedemptionResponse>(
            `${API_URL}/api/public/coupons/${couponId}/redeem`, 
            data,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
    },

    getBrandingSettings: (couponId: string) => {
        return axios.get(`${API_URL}/api/public/settings/branding/${couponId}`);
    },

    getSubscriberDetails: (couponId: string, subscriberId: string) => {
        return axios.get<SubscriberDetailsResponse>(
            `${API_URL}/api/public/coupons/${couponId}/subscriber-details`,
            { params: { subscriberId } }
        );
    }
};
